@if ((data | async)?.content ) {<div></div>}